import React from "react";

export function ErrorMessage() {
  return (
    <div id="error-message">
      <h1>
        This screen is too small, please open this website in a larger device
      </h1>
    </div>
  );
}
